var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMessageOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 10V9.52308L4.25617 9.34856C3.37843 9.00341 2.74841 8.55109 2.33683 8.00436C1.93045 7.46454 1.7 6.78396 1.7 5.90909C1.7 4.82345 2.29956 3.78159 3.30451 2.98691C4.30809 2.19332 5.65608 1.7 7 1.7C8.34392 1.7 9.69191 2.19332 10.6955 2.98691C11.7004 3.78159 12.3 4.82345 12.3 5.90909C12.3 6.77793 12.0416 7.64123 11.4778 8.34789C10.9183 9.04925 10.0218 9.64178 8.66272 9.91359L8.5708 9.93198L8.48695 9.9739L4.7 11.8674V10Z",
    stroke: "#9B51E0",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessageOn);
export default __webpack_public_path__ + "static/media/ico-message-on.cf8d2c344491bf11423022313730b0fe.svg";
export { ForwardRef as ReactComponent };